import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["expanded", "label", "onChange", "onClick", "onContextMenu", "hideIcon", "fullWidth", "iconProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PT from 'prop-types';
import { iconPropTypes } from '@scaleflex/icons/icon.prop-types';
import { intrinsicComponent } from '../../utils/functions';
import ArrowTick from '../arrow-tick';
import { Position as ArrowTickType } from '../../utils/types';
import Styled from './accordion-header.styles';
var AccordionHeader = intrinsicComponent(function (_ref, ref) {
  var expanded = _ref.expanded,
    label = _ref.label,
    onChange = _ref.onChange,
    _onClick = _ref.onClick,
    onContextMenu = _ref.onContextMenu,
    hideIcon = _ref.hideIcon,
    fullWidth = _ref.fullWidth,
    iconPropsData = _ref.iconProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.Header, _extends({
    ref: ref,
    onClick: function onClick(event) {
      if (typeof onChange === 'function') {
        onChange(!expanded);
      }
      if (typeof _onClick === 'function') {
        _onClick(event);
      }
    },
    fullWidth: fullWidth
  }, rest), /*#__PURE__*/React.createElement(Styled.Label, {
    onContextMenu: onContextMenu
  }, label), !hideIcon && /*#__PURE__*/React.createElement(Styled.Icon, {
    onContextMenu: onContextMenu
  }, /*#__PURE__*/React.createElement(ArrowTick, {
    type: expanded ? ArrowTickType.Top : ArrowTickType.Bottom,
    IconProps: _objectSpread({
      size: 11
    }, iconPropsData)
  })));
});
AccordionHeader.defaultProps = {
  expanded: false,
  hideIcon: false,
  fullWidth: false
};
AccordionHeader.propTypes = {
  label: PT.node.isRequired,
  expanded: PT.bool,
  hideIcon: PT.bool,
  fullWidth: PT.bool,
  onChange: PT.func,
  iconProps: PT.exact(iconPropTypes)
};
export default AccordionHeader;